export default __webpack_public_path__ + "static/media/footer_splash_mobile.2856c4af.svg";